import { Box, Button, styled, Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import {
  EPOCUS_PRIMARY,
  EPOCUS_PRIMARY_DARK,
  EPOCUS_STATUS_DRAFT_BG,
  EPOCUS_STATUS_DRAFT_TEXT,
  EPOCUS_SUCCESS,
  EPOCUS_SUCCESS_BG,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "../../../_lib/epocus-palette";

const PanelRoot = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: 8,
  padding: "48px 24px",
  flex: 1,
});

const CheckCircle = styled(Box)({
  width: 60,
  height: 60,
  marginBottom: 8,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: EPOCUS_SUCCESS_BG,
  border: `1px solid ${EPOCUS_SUCCESS}`,
  color: EPOCUS_SUCCESS,
});

const Title = styled(Typography)({
  fontSize: rem(20),
  fontWeight: 700,
  color: EPOCUS_TEXT_PRIMARY,
});

const Detail = styled(Typography)({
  fontSize: rem(14),
  color: EPOCUS_TEXT_SECONDARY,
  maxWidth: 380,
});

const EscalationNote = styled(Typography)({
  marginTop: 4,
  padding: "6px 12px",
  borderRadius: 20,
  fontSize: rem(12.5),
  fontWeight: 600,
  backgroundColor: EPOCUS_STATUS_DRAFT_BG,
  color: EPOCUS_STATUS_DRAFT_TEXT,
});

const NextButton = styled(Button)({
  marginTop: 16,
  minHeight: 48,
  borderRadius: 10,
  textTransform: "none",
  fontSize: rem(15),
  fontWeight: 700,
  backgroundColor: EPOCUS_PRIMARY,
  color: EPOCUS_WHITE,
  "&:hover": { backgroundColor: EPOCUS_PRIMARY_DARK },
});

export const SignedReviewPanel: FC<{
  escalated: boolean;
  encounterComplete: boolean;
  onNext: () => void;
  nextLabel: string;
}> = ({ escalated, encounterComplete, onNext, nextLabel }) => (
  <PanelRoot>
    <CheckCircle>
      <CheckIcon />
    </CheckCircle>
    <Title>Review signed</Title>
    <Detail>
      {encounterComplete
        ? "Study locked, moved out of your queue, and feedback routed to the performer. Audit event recorded."
        : "Exam locked and feedback routed to the performer. The encounter stays in your queue until its remaining exams are signed. Audit event recorded."}
    </Detail>
    {escalated && <EscalationNote>Escalated for second review</EscalationNote>}
    <NextButton variant="contained" disableElevation onClick={onNext}>
      {nextLabel}
    </NextButton>
  </PanelRoot>
);
